import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanoAcaoService } from "./../../../services/plano-acao.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoModel, IRecomendacaoOsaExecucaoMatrizModel } from '../../../models/plano-acao-model';
import { sobreporAvaliacaoMaisRecente } from '../../../shared/util/plano-acao-historico-abas';

interface IMonitor {
  responsavelNomeMonitoramento: string;
  responsavelCargoMonitoramento: string;
}

@Component({
  selector: 'app-plano-acao-monitor-imprimir',
  templateUrl: './plano-acao-monitor-imprimir.component.html',
  styleUrls: ['./plano-acao-monitor-imprimir.component.scss']
})
export class PlanoAcaoMonitorImprimirComponent implements OnInit {

  public model: IPlanoAcaoModel = {} as IPlanoAcaoModel;
  public id: number = 0;
  public dataHoje: Date = this.truncateDate(new Date());
  public minuta: boolean = false;
  public monitores: IMonitor[] = [];

  constructor(
    public matDialog: MatDialog,
    public route: ActivatedRoute,
    private planoAcaoService: PlanoAcaoService,
    private dialogRef: MatDialogRef<PlanoAcaoMonitorImprimirComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.id = data?.id;
  }

  ngOnInit(): void {
    // Demanda 68742 linha 41: snapshot de versão dispensa nova consulta.
    if (this.data?.snapshot) {
      this.aplicarSnapshot(this.data.snapshot);
      this.complementarAvaliacaoMaisRecente();
      return;
    }
    this.getImprimirPlanoAcao(this.id);
  }

  private complementarAvaliacaoMaisRecente(): void {
    sobreporAvaliacaoMaisRecente(this.model?.acoes || [], (id) => this.planoAcaoService.obterHistoricoAcao(id))
      .then(() => {
        this.monitores = this.getMonitores(
          (this.model.acoes || []).filter(a => a.responsavelNomeMonitoramento)
        );
      });
  }

  private aplicarSnapshot(snapshot: IPlanoAcaoModel): void {
    this.model = snapshot;
    this.monitores = this.getMonitores(
      (this.model.acoes || []).filter(a =>
        a.responsavelNomeMonitoramento
      )
    );
  }

  getImprimirPlanoAcao(Id: number) {

    this.planoAcaoService
      .imprimirPorId(this.id)
      .then((res) => {
        this.model = res.dados;

        this.monitores = this.getMonitores(
          (this.model.acoes || []).filter(a =>
            a.responsavelNomeMonitoramento
          )
        );
        this.complementarAvaliacaoMaisRecente();
      })
      .catch((err) => {
      })
  }

  onImprimir() {
    // opcional — pode deixar vazio, o print já é interno
  }

  onFechar() {
    this.dialogRef.close();
  }

  private truncateDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  getRowSpanAcao(item: IAcaoPlanoAcaoModel): number {
    if (!item.recomendacoes || item.recomendacoes.length === 0) {
      return 1;
    }

    let total = 0;

    item.recomendacoes.forEach((r: IAcaoPlanoAcaoRecomendacaoModel) => {
      if (r.recomendacao.itensVinculados && r.recomendacao.itensVinculados.length > 0) {
        total += r.recomendacao.itensVinculados.length;
      } else {
        total += 1;
      }
    });

    return total;
  }


  getRowSpanRecomendacao(r: any): number {
    const qtd = r.recomendacao?.itensVinculados?.length;
    return qtd && qtd > 0 ? qtd : 1;
  }

  getMonitores(acoes: IAcaoPlanoAcaoModel[]): IMonitor[] {
    const map = new Map<string, IMonitor>();

    acoes.forEach(a => {
      if (!a.responsavelNomeMonitoramento) return;

      const key = `${a.responsavelNomeMonitoramento}-${a.responsavelCargoMonitoramento}`;

      if (!map.has(key)) {
        map.set(key, {
          responsavelNomeMonitoramento: a.responsavelNomeMonitoramento,
          responsavelCargoMonitoramento: a.responsavelCargoMonitoramento
        });
      }
    });

    return Array.from(map.values());
  }

  getStatusClass(codigo: number): string {
    switch (codigo) {
      case 1: return 'bg-gray-dark';
      case 2: return 'bg-info';
      case 3: return 'bg-warning';
      case 4: 
      case 5: return 'bg-danger';
      case 6: 
      case 7: return 'bg-success';
      case 8: return 'bg-info';
      case 9: return 'bg-primary';
      case 10: return 'bg-atendida-parcialmente';
      case 11: return 'bg-warning';
      case 12: return 'bg-success';
      case 13: return 'bg-gray-dark';
      default: return 'bg-secondary';
    }
  }



}

